module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-19-53b39a26c1d9929001996da6e77490d8.jpg";